import React from 'react'

import { userPermission, profilePaths, billingPermission } from './constants'

import CompanyDataPage from '../pages/CompanyDataPage/CompanyDataPage'
import UsersCreatePage from '../pages/UsersCreatePage/UsersCreatePage'
import VacancyManagerPage from '../pages/VacancyManagerPage'
import BillingPage from '../pages/BillingPage'
import MessagesPage from '../pages/MessagesPage'
import SearchPage from '../pages/SearchPage'
import SettingsPage from '../pages/SettingsPage/SettingsPage'
import StatisticPage from '../pages/StatisticPage'
import { isPathAvailable, isServiceAvailable } from '../helpers/helpers'
import store from '../redux/store'

export const getProfileRoutes = () => {
  const { is_active: isActiveCompany } = store.getState().company
  const hasFullProfileAccess = !isActiveCompany

  return {
    ...((hasFullProfileAccess ||
      (isPathAvailable(userPermission.seafarers_favourites) &&
        isPathAvailable(userPermission.vacancy_requests)))
      ? {
          [profilePaths.seafarers]: {
            Component: <SearchPage />,
          },
        }
      : {}),

    ...((hasFullProfileAccess ||
      (isPathAvailable(userPermission.seafarer_chat) &&
        isServiceAvailable(billingPermission.instant_messaging)))
      ? {
          [`${profilePaths.chat}/`]: {
            Component: <MessagesPage />,
            exact: true,
          },
          [`${profilePaths.chat}/:id`]: {
            Component: <MessagesPage />,
          },
        }
      : {}),

    ...((hasFullProfileAccess ||
      (isPathAvailable(userPermission.vacancies) && isPathAvailable(userPermission.vessels)))
      ? {
          [profilePaths.vacancy_manager]: {
            Component: <VacancyManagerPage />,
          },
        }
      : {}),

    ...((hasFullProfileAccess || isPathAvailable(userPermission.users))
      ? {
          [profilePaths.users]: {
            Component: <UsersCreatePage />,
          },
        }
      : {}),

    ...((hasFullProfileAccess || isPathAvailable(userPermission.company_profile))
      ? {
      [profilePaths.company_data]: {
        Component: <CompanyDataPage />,
        exact: true,
      },
    }
      : {}),

    ...((hasFullProfileAccess || isPathAvailable(userPermission.billing))
      ? {
          [profilePaths.billing]: {
            Component: <BillingPage />,
          },
        }
      : {}),

    [profilePaths.statistic]: {
      Component: <StatisticPage />,
    },

    [profilePaths.settings]: {
      Component: <SettingsPage />,
    },
  }
}
